import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo } from "@client/controls/Form/component";
import * as React from "react";
import SendResetLinkButton from "./Button";

export type MapProps = RootContainerProps & {
  fields: FormFieldInfo[];
  error: string | null;

  isLinkSent: boolean | null;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) =>
  props.isLinkSent ? null : (
    <Form
      {...getRootContainerProps(props)}
      fields={props.fields}
      Button={SendResetLinkButton}
      buttonProps={getRootContainerProps(props)}
      error={props.error}
    />
  );
